// extracted by mini-css-extract-plugin
module.exports = {"buttonsBlock":"style_buttonsBlock__cST1H","buttonsBlock__payment":"style_buttonsBlock__payment__aN_e7","buttonsBlock__offer":"style_buttonsBlock__offer__g2B0q"};